import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ArrowRightIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.98399 12.584L3.98399 10.616L16.176 10.616L10.584 4.99996L12 3.58397L20.016 11.6L12 19.616L10.584 18.2L16.176 12.584L3.98399 12.584Z'
                fill='currentColor'
            />
        </>
    ),
})

ArrowRightIcon.displayName = 'ArrowRightIcon'
